import { MouseEventHandler } from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { TableSortCellProps } from './types';
import { TableHead } from 'stubben-edge-unified-frontend-react-components';
import { styleTableSortCell } from './style';
import clsx from 'clsx';

const alignClassName = (align?: TableSortCellProps['align']) => {
  switch (align) {
    case 'center':
      return 'text-center';
    case 'right':
      return 'text-right';
    case 'justify':
      return 'text-justify';
    case 'left':
      return 'text-left';
    default:
      return undefined;
  }
};

const TableSortCell = (props: TableSortCellProps) => {
  const {
    active,
    direction,
    className,
    children,
    onClick,
    onSortChange,
    align,
    ...rest
  } = props;
  const cls = styleTableSortCell(props);

  const handleClick: MouseEventHandler<HTMLTableCellElement> = (e) => {
    if (onClick) {
      onClick(e);
    }
    if (onSortChange) {
      if (!active) {
        onSortChange(true, 'asc');
      } else if (direction === 'asc') {
        onSortChange(true, 'desc');
      } else {
        onSortChange(false);
      }
    }
  };

  const SortIcon = !active
    ? ArrowUpDown
    : direction === 'asc'
      ? ArrowUp
      : ArrowDown;

  return (
    <TableHead
      className={clsx(cls.main, alignClassName(align), className)}
      onClick={handleClick}
      {...rest}
    >
      <span className={clsx(cls.inner)}>
        {children}
        <SortIcon className={clsx(cls.icon)} aria-hidden />
      </span>
    </TableHead>
  );
};

export default TableSortCell;
